<template>
    <b-btn
        v-bind="$attrs"
        class="btn-circle"
        size="sm"
        variant="outline-primary"
        v-on="$listeners"
    >
        <fa :icon="`chevron-${left ? 'left' : 'right'}`" />
    </b-btn>
</template>

<script>
export default {
    name: 'BtnArrow',
    props: {
        left: {
            type: Boolean,
            default: false,
        },
    },
};
</script>